import { getGeneralLedgerData, getledgerbalance } from "./generalledger.js";

export function getAssetAccounts(context) {  //20250213
    const {
        assetaccounts,
        currencies,
        exchangerates,
        basecurrency
    } = context;

    const generalledgerdata = getGeneralLedgerData(context);
    let filteredledgerdata = generalledgerdata
        .filter(data => data.accounttype == 'assetaccounts')

    const data = [];

    let currencysymbol = currencies.find(curr => curr.id == basecurrency)?.symbol

    assetaccounts.forEach((account) => {
        let accountledgers = filteredledgerdata
            .filter(data => data.accountid == account.id)

        data.push({
            id: account.id,
            name: account.name,
            currencyid: account.currencyid,
            currencysymbol: currencysymbol,
            balance: getledgerbalance(accountledgers, exchangerates, basecurrency, 'assetaccounts'),
        });
    });

    data.sort((a, b) => {
        const nameComparison = a.name.localeCompare(b.name, 'en', { numeric: true });
        if (nameComparison === 0) {
            return parseFloat(a.balance) - parseFloat(b.balance);
        }
        return nameComparison;
    });

    return data;
}
